import React, { useEffect, useState } from 'react';
import { Modal, Form, Row, Col, Button as BootstrapButton, Tabs, Tab } from 'react-bootstrap';
import { Formik, FieldArray } from 'formik';
import * as yup from 'yup';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { getAccountAuthInfoByIdAccountAction, getAccountInfoByIdAccountAction } from '../../../../../store/reducers/account';
import { Post, Get, Put, DeleteSingle } from '../../../../../utils/httpProvider';
import { ADDRESS_API, DOITUONG_API, DONVI_API, DONVIDAOTAO_API, HOSO_TUYENSINH_API, QUOCGIA_API, TRINHDO_API, VANBANGDAIHOC_API, LOPDAOTAOLIENTUC_API, LOPDAOTAOTHUCHANH_API } from '@app/utils/apiUrl';
import { trangThaiHoSoDuTuyenValue, objectAccountGender, objectObjectAccount, loaiVanBangValue, objectLoaiVanBang } from '../../../../../utils/define';
import DocumentInput from '../../../../../components/document-input/DocumentInput';
import * as moment from 'moment';
import { userManager } from '@app/utils/oidc';
import Select from 'react-select';
import { useMutation, useQuery, useQueryClient } from 'react-query';

const baseSchema = yup.object().shape({
    fullName: yup.string().required('Vui lòng cập nhật họ tên'),
    dateOfBirthStr: yup.string().required('Vui lòng cập nhật ngày sinh'),
    email: yup.string().required('Vui lòng cập nhật email'),
    phoneNumber: yup.string().required('Vui lòng cập nhật số điện thoại'),
    donViName: yup.string().required('Vui lòng cập nhật đơn vị công tác'),
    hoTenNguoiLienHe: yup.string().required('Vui lòng nhập họ tên người liên hệ').max(255, 'Tối đa 255 ký tự'),
    quanHeNguoiLienHe: yup.string().nullable().max(255, 'Tối đa 255 ký tự'),
    sdtNguoiLienHe: yup.string().required('Vui lòng nhập số điện thoại người liên hệ').max(50, 'Tối đa 50 ký tự'),
    noiSinh: yup.string().required('Vui lòng chọn nơi sinh').max(500, 'Tối đa 500 ký tự'),
    isDoiTuongMienGiam: yup.string().required('Vui lòng chọn đối tượng miễn giảm'),

    fileAnhChanDung: yup.string().required('Vui lòng đính kèm file ảnh chân dung'),
    fileAnhCccd: yup.string().required('Vui lòng đính kèm file ảnh căn cước công dân'),
    fileDonXinDuTuyen: yup.string().required('Vui lòng đính kèm đơn đăng ký học'),
    fileBangTotNghiep: yup.string().required('Vui lòng đính kèm bằng tốt nghiệp'),
    fileSoYeuLyLich: yup.string().required('Vui lòng đính kèm sơ yếu lý lịch'),
    loaiTuyenSinh: yup.number(),
    chucDanhId: yup.string().when('loaiTuyenSinh', {
        is: 2,
        then: (schema) => schema.required('Vui lòng chọn chức danh đăng ký đào tạo'),
        otherwise: (schema) => schema.nullable()
    }),

    vanBangDaiHocs: yup.array().of(
        yup.object().shape({
            loaiVanBang: yup.number().required('Vui lòng chọn loại văn bằng'),
            tenTruongNuocNgoai: yup.string().nullable().when('loaiVanBang', {
                is: 1, // NuocNgoai
                then: (schema) => schema.required('Vui lòng nhập tên trường').max(500, 'Tối đa 500 ký tự'),
                otherwise: (schema) => schema.max(500, 'Tối đa 500 ký tự')
            }),
            donViDaoTaoId: yup.string().nullable().when('loaiVanBang', {
                is: 2, // VanBangTrongNuoc
                then: (schema) => schema.required('Vui lòng chọn trường đào tạo'),
                otherwise: (schema) => schema
            }),
            quocGiaId: yup.string().nullable().required('Vui lòng chọn quốc gia'),
            trinhDoId: yup.string().nullable().required('Vui lòng chọn hệ đào tạo'),
            namTotNghiep: yup.number().nullable().required('Vui lòng nhập năm tốt nghiệp').typeError('Năm tốt nghiệp phải là số'),
            fileMinhChung: yup.string().required('Vui lòng đính kèm file văn bằng')
        })
    ).min(1, 'Vui lòng thêm ít nhất một quá trình đào tạo')
});

const DangKyHoSoLopDaoTaoModal = ({ show, handleClose, dotTuyenSinhId, hoSoId, loaiTuyenSinh }) => {
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    const itemAccountAuthInfo = useSelector((state) => state.account.itemAccountAuthInfo);
    const itemAccountInfo = useSelector((state) => state.account.itemAccountInfo);
    const [accountId, setAccountId] = useState('');
    const [cccdNumber, setCccdNumber] = useState('');

    const { data: hoSo } = useQuery(['hoSoTuyenSinhDetail', hoSoId], () => Get(HOSO_TUYENSINH_API.GET_ITEM, hoSoId), { enabled: !!hoSoId });
    const { data: vanBangRes } = useQuery(['vanBang', hoSoId], () => Get(VANBANGDAIHOC_API.GET_BY_HOSO_ID, hoSoId), { enabled: !!hoSoId });

    const { data: provincesRes } = useQuery(['provincesData'], () => Get(ADDRESS_API.GET_PROVINCES), { enabled: show });
    const provinceOptions = Array.isArray(provincesRes) 
        ? provincesRes.map(item => ({ value: item.id, label: item.title })) 
        : [];

    const { data: trinhDoRes } = useQuery(['trinhDoData'], () => Get(TRINHDO_API.GET_ALL_PAGING + '?pageSize=1000'), { enabled: show });
    const trinhDoOptions = (trinhDoRes?.data?.$values || trinhDoRes?.data || [])
        .map(item => ({ value: item.id, label: item.tenTrinhDo }));

    const { data: donViDaoTaoRes } = useQuery(['donViDaoTaoData'], () => Get(DONVIDAOTAO_API.GET_ALL_PAGING + '?pageSize=1000'), { enabled: show });
    const donViDaoTaoOptions = (donViDaoTaoRes?.data?.$values || donViDaoTaoRes?.data || [])
        .map(item => ({ value: item.id, label: item.tenDonViDaoTao }));

    const { data: quocGiaRes } = useQuery(['quocGiaData'], () => Get(QUOCGIA_API.GET_ALL_PAGING + '?pageSize=1000'), { enabled: show });
    const quocGiaOptions = (quocGiaRes?.data?.$values || quocGiaRes?.data || [])
        .map(item => ({ value: item.id, label: item.tenQuocGia }));

    const { data: doiTuongRes } = useQuery(['doiTuongDataChucDanh'], () => Get(DOITUONG_API.GET_PAGING, null, { PageIndex: 1, PageSize: 1000 }), { enabled: show });
    const allowedChucDanhs = ['bác sĩ', 'điều dưỡng', 'ktv', 'y sĩ'];
    const chucDanhOptions = (doiTuongRes?.data?.$values || doiTuongRes?.data || [])
        .filter(item => allowedChucDanhs.includes((item.tenDoiTuong || '').toLowerCase()))
        .map(item => ({ value: item.id || item.Id, label: item.tenDoiTuong || item.TenDoiTuong }));

    const { data: khoahocData } = useQuery(['khoahocDetail', dotTuyenSinhId, loaiTuyenSinh], () => {
        if (loaiTuyenSinh === 1) return Get(LOPDAOTAOLIENTUC_API.GET_ITEM, dotTuyenSinhId);
        if (loaiTuyenSinh === 2) return Get(LOPDAOTAOTHUCHANH_API.GET_ITEM, dotTuyenSinhId);
        return null;
    }, { enabled: !!dotTuyenSinhId && show });

    const tenKhoaHoc = khoahocData?.tenKhoaHoc || khoahocData?.TenKhoaHoc || khoahocData?.data?.tenKhoaHoc || khoahocData?.data?.TenKhoaHoc || hoSo?.tenDotTuyenSinh || hoSo?.TenDotTuyenSinh || '';
    const soHoSoDisplay = hoSo?.soHoSo || hoSo?.SoHoSo || '';

    useEffect(() => {
        if (show) {
            const fetchInfo = async () => {
                const user = await userManager.getUser();
                if (user?.profile?.preferred_username) {
                    setCccdNumber(user.profile.preferred_username);
                }
                const accId = user?.profile?.sub || null;
                if (accId) {
                    setAccountId(accId);
                    dispatch(getAccountAuthInfoByIdAccountAction(accId));
                    dispatch(getAccountInfoByIdAccountAction(accId));
                }
            };
            fetchInfo();
        }
    }, [show, dispatch]);

    const fullName = [
        itemAccountAuthInfo?.lastName,
        itemAccountAuthInfo?.middleName,
        itemAccountAuthInfo?.firstName
    ].filter(Boolean).join(' ') || '';

    const donViName = itemAccountInfo?.donVis?.length > 0 
        ? itemAccountInfo.donVis.map(d => d.tenDonVi).join(', ') 
        : (itemAccountInfo?.donViNgoaiVien || '');

    const donViId = itemAccountInfo?.donVis?.length > 0 ? itemAccountInfo.donVis[0].id : null;
    const donViNgoaiVien = itemAccountInfo?.donVis?.length > 0 ? null : itemAccountInfo?.donViNgoaiVien;

    const email = itemAccountAuthInfo?.email || '';
    const phoneNumber = itemAccountAuthInfo?.phoneNumber || '';
    
    let doiTuongVal = itemAccountAuthInfo?.objectAccount === 'quanNhan' ? 1 : 2;
    const doiTuongName = objectObjectAccount.find(x => x.value === itemAccountAuthInfo?.objectAccount)?.label || 'Khác';

    let gioiTinhVal = itemAccountAuthInfo?.accountGender === 'female' ? 2 : 1;
    const accountGenderName = objectAccountGender.find(x => x.value === itemAccountAuthInfo?.accountGender)?.label || 'Nam';

    const dateOfBirth = itemAccountAuthInfo?.dateOfBirth;
    const dateOfBirthStr = dateOfBirth ? moment(dateOfBirth).format('DD/MM/YYYY') : '';
    
    const soCCCD = hoSo?.soCCCD || hoSo?.SoCCCD || cccdNumber || itemAccountAuthInfo?.identityCardNumber || '';
    const ngayCapCCCD = hoSo?.ngayCapCCCD || hoSo?.NgayCapCCCD || itemAccountAuthInfo?.issuanceDateOfIdentityCard;
    const ngayCapCCCDStr = ngayCapCCCD ? moment(ngayCapCCCD).format('DD/MM/YYYY') : '';
    const noiCapCCCD = hoSo?.noiCapCCCD || hoSo?.NoiCapCCCD || itemAccountAuthInfo?.issuancePlaceOfIdentityCard || '';
    const thuongTruTinhThanh = hoSo?.thuongTruTinhThanh || hoSo?.ThuongTruTinhThanh || itemAccountAuthInfo?.hkttAdressProvinceCity || '';
    const thuongTruXaPhuong = hoSo?.thuongTruXaPhuong || hoSo?.ThuongTruXaPhuong || itemAccountAuthInfo?.hkttAdressWardCommune || '';
    const thuongTruDiaChi = hoSo?.thuongTruDiaChi || hoSo?.ThuongTruDiaChi || itemAccountAuthInfo?.address || '';

    const submitHoSoFunc = useMutation((payload) => payload.id ? Put(HOSO_TUYENSINH_API.UPDATE_ITEM, payload.id, payload) : Post(HOSO_TUYENSINH_API.ADD_ITEM, null, payload));
    const submitVanBangDaiHocFunc = useMutation((payload) => payload.id ? Put(VANBANGDAIHOC_API.UPDATE_ITEM, payload.id, payload) : Post(VANBANGDAIHOC_API.ADD_ITEM, null, payload));
    const deleteVanBangDaiHocFunc = useMutation((id) => DeleteSingle(VANBANGDAIHOC_API.DELETE_ITEM, id));

    const handleSubmit = async (values, actions) => {
        const payload = {
            accountId: accountId,
            dotTuyenSinhId: dotTuyenSinhId,
            loaiTuyenSinh: loaiTuyenSinh || 1, // Default LienTuc
            hoTen: fullName,
            doiTuong: doiTuongVal,
            ngaySinh: dateOfBirth ? moment(dateOfBirth).format('YYYY-MM-DDTHH:mm:ss') : null,
            noiSinh: values.noiSinh,
            isDoiTuongMienGiam: values.isDoiTuongMienGiam === 'true',
            gioiTinh: gioiTinhVal,
            email: email,
            soDienThoai: phoneNumber,
            hoTenNguoiLienHe: values.hoTenNguoiLienHe,
            quanHeNguoiLienHe: values.quanHeNguoiLienHe,
            sdtNguoiLienHe: values.sdtNguoiLienHe,
            soCCCD: soCCCD,
            chucDanhId: values.chucDanhId,
            ngayCapCCCD: ngayCapCCCD ? moment(ngayCapCCCD).format('YYYY-MM-DDTHH:mm:ss') : null,
            noiCapCCCD: noiCapCCCD,
            thuongTruTinhThanh: thuongTruTinhThanh,
            thuongTruXaPhuong: thuongTruXaPhuong,
            thuongTruDiaChi: thuongTruDiaChi,
            donViId: donViId,
            donViNgoaiVien: donViNgoaiVien,
            fileAnhChanDung: values.fileAnhChanDung,
            fileAnhCccd: values.fileAnhCccd,
            fileDonXinDuTuyen: values.fileDonXinDuTuyen,
            fileSoYeuLyLich: values.fileSoYeuLyLich,
            fileBangTotNghiep: values.fileBangTotNghiep,
            fileVanBangKhac: values.fileVanBangKhac,
            fileMinhChungLePhi: hoSo?.fileMinhChungLePhi || hoSo?.FileMinhChungLePhi || '',
            fileMinhChungMienGiam: values.fileMinhChungMienGiam,
            soHoSo: hoSo?.soHoSo || hoSo?.SoHoSo || '',
            ghiChuChinhSua: hoSo?.ghiChuChinhSua || hoSo?.GhiChuChinhSua || '',
            diemHoSo: hoSo?.diemHoSo ?? hoSo?.DiemHoSo ?? null,
            trangThaiHoSoDuTuyen: trangThaiHoSoDuTuyenValue.choGui
        };

        if (hoSoId) payload.id = hoSoId;

        try {
            const hoSoResult = await submitHoSoFunc.mutateAsync(payload);
            let returnedHoSoId = hoSoId;
            if (hoSoResult && hoSoResult.ok) {
                if (!returnedHoSoId) {
                    try {
                        const data = await hoSoResult.json();
                        returnedHoSoId = data.id || data.data?.id;
                    } catch (e) {
                        console.error("Parse json error", e);
                    }
                }
            } else {
                throw new Error('Có lỗi khi lưu hồ sơ: ' + hoSoResult.statusText);
            }

            if (!returnedHoSoId) throw new Error('Không lấy được ID hồ sơ.');

            // Process Van Bang Dai Hoc
            const currentVanBangIds = (vanBangRes?.data?.$values || vanBangRes?.data || []).map(x => x.id || x.Id);
            const submittedVanBangIds = (values.vanBangDaiHocs || []).filter(x => x.id).map(x => x.id);
            const vanBangToDelete = currentVanBangIds.filter(id => !submittedVanBangIds.includes(id));
            
            for (const id of vanBangToDelete) {
                await deleteVanBangDaiHocFunc.mutateAsync(id);
            }
            
            for (const vb of (values.vanBangDaiHocs || [])) {
                const vbPayload = { ...vb, hoSoTuyenSinhId: returnedHoSoId };
                await submitVanBangDaiHocFunc.mutateAsync(vbPayload);
            }

            toast.success('Lưu hồ sơ thành công!');
            if (loaiTuyenSinh === 1) {
                queryClient.invalidateQueries('lopDaoTaoLienTucDangKyData');
            } else if (loaiTuyenSinh === 2) {
                queryClient.invalidateQueries('lopDaoTaoThucHanhDangKyData');
            }
            handleClose();
        } catch (error) {
            console.error(error);
            toast.error('Có lỗi xảy ra khi lưu hồ sơ.');
        } finally {
            actions.setSubmitting(false);
        }
    };

    const initialValues = {
        fullName, dateOfBirthStr, email, phoneNumber, donViName,
        loaiTuyenSinh: loaiTuyenSinh,
        isDoiTuongMienGiam: hoSo?.isDoiTuongMienGiam !== undefined && hoSo?.isDoiTuongMienGiam !== null ? String(hoSo.isDoiTuongMienGiam) : (hoSo?.IsDoiTuongMienGiam !== undefined && hoSo?.IsDoiTuongMienGiam !== null ? String(hoSo.IsDoiTuongMienGiam) : ''),
        noiSinh: hoSo?.noiSinh || hoSo?.NoiSinh || '',
        thuongTruTinhThanh: thuongTruTinhThanh,
        thuongTruXaPhuong: thuongTruXaPhuong,
        thuongTruDiaChi: thuongTruDiaChi,
        hoTenNguoiLienHe: hoSo?.hoTenNguoiLienHe || hoSo?.HoTenNguoiLienHe || '',
        quanHeNguoiLienHe: hoSo?.quanHeNguoiLienHe || hoSo?.QuanHeNguoiLienHe || '',
        sdtNguoiLienHe: hoSo?.sdtNguoiLienHe || hoSo?.SDTNguoiLienHe || '',
        chucDanhId: hoSo?.chucDanhId || hoSo?.ChucDanhId || '',
        
        fileAnhChanDung: hoSo?.fileAnhChanDung || hoSo?.FileAnhChanDung || '',
        fileAnhCccd: hoSo?.fileAnhCccd || hoSo?.FileAnhCccd || '',
        fileDonXinDuTuyen: hoSo?.fileDonXinDuTuyen || hoSo?.FileDonXinDuTuyen || '',
        fileSoYeuLyLich: hoSo?.fileSoYeuLyLich || hoSo?.FileSoYeuLyLich || '',
        fileBangTotNghiep: hoSo?.fileBangTotNghiep || hoSo?.FileBangTotNghiep || '',
        fileVanBangKhac: hoSo?.fileVanBangKhac || hoSo?.FileVanBangKhac || '',
        fileMinhChungMienGiam: hoSo?.fileMinhChungMienGiam || hoSo?.FileMinhChungMienGiam || '',

        vanBangDaiHocs: (vanBangRes?.data?.$values || vanBangRes?.data || []).map(item => {
            let loaiVB = item.loaiVanBang ?? item.LoaiVanBang ?? '';
            if (typeof loaiVB === 'string' && loaiVanBangValue) {
                const camelCase = loaiVB.charAt(0).toLowerCase() + loaiVB.slice(1);
                loaiVB = loaiVanBangValue[camelCase] !== undefined ? loaiVanBangValue[camelCase] : (loaiVanBangValue[loaiVB] ?? loaiVB);
            }
            return {
                id: item.id || item.Id,
                loaiVanBang: loaiVB,
                donViDaoTaoId: item.donViDaoTaoId || item.DonViDaoTaoId || '',
                tenTruongNuocNgoai: item.tenTruongNuocNgoai || item.TenTruongNuocNgoai || '',
                quocGiaId: item.quocGiaId || item.QuocGiaId || '',
                trinhDoId: item.trinhDoId || item.TrinhDoId || '',
                namTotNghiep: item.namTotNghiep || item.NamTotNghiep || '',
                fileMinhChung: item.fileMinhChung || item.FileMinhChung || '',
            };
        })
    };

    const defaultQuocGiaId = quocGiaOptions?.find(q => q.label.toLowerCase() === 'việt nam' || q.label.toLowerCase() === 'viet nam')?.value || '';

    if (initialValues.vanBangDaiHocs.length === 0) {
        initialValues.vanBangDaiHocs.push({
            loaiVanBang: loaiVanBangValue.vanBangTrongNuoc, donViDaoTaoId: '', tenTruongNuocNgoai: '', quocGiaId: defaultQuocGiaId, trinhDoId: '', namTotNghiep: '', fileMinhChung: ''
        });
    }

    return (
        <Modal show={show} onHide={handleClose} size="xl" backdrop="static" keyboard={false} style={{ zIndex: 9999 }}>
            <Modal.Header closeButton className="bg-primary text-white">
                <Modal.Title><i className="fas fa-file-signature mr-2"></i> {loaiTuyenSinh === 1 ? 'Đăng ký Lớp Đào tạo liên tục' : 'Đăng ký Lớp Đào tạo thực hành'}</Modal.Title>
            </Modal.Header>
            <Formik initialValues={initialValues} enableReinitialize validationSchema={baseSchema} onSubmit={handleSubmit}>
                {({ handleSubmit, handleChange, setFieldValue, values, errors, touched, isSubmitting, submitCount }) => (
                    <Form noValidate onSubmit={handleSubmit}>
                        <Modal.Body className="p-0" style={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' }}>
                            <Tabs defaultActiveKey="thong-tin" id="ho-so-tabs" className="custom-tabs px-4 pt-3 border-bottom-0">
                                <Tab eventKey="thong-tin" title={<span><i className="fas fa-user-circle mr-1"></i> Thông tin thí sinh</span>}>
                                    <div className="bg-light p-4 rounded border mt-3 mb-4 mx-4 shadow-sm">
                                        <Row>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="font-weight-bold text-muted small">Họ tên <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control type="text" value={fullName} disabled className="shadow-none bg-white" />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="font-weight-bold text-muted small">Đối tượng <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control type="text" value={doiTuongName} disabled className="shadow-none bg-white" />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="font-weight-bold text-muted small">Ngày sinh <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control type="text" value={dateOfBirthStr} disabled className="shadow-none bg-white" />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="font-weight-bold text-muted small">Giới tính <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control type="text" value={accountGenderName} disabled className="shadow-none bg-white" />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="font-weight-bold text-muted small">Số CCCD <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control type="text" value={soCCCD} disabled className="shadow-none bg-white" />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="font-weight-bold text-muted small">Ngày cấp CCCD <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control type="text" value={ngayCapCCCDStr} disabled className="shadow-none bg-white" />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="font-weight-bold text-muted small">Nơi cấp CCCD <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control type="text" value={noiCapCCCD} disabled className="shadow-none bg-white" />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="font-weight-bold text-muted small">Thường trú (Tỉnh / Thành phố) <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control type="text" value={thuongTruTinhThanh} disabled className="shadow-none bg-white" />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="font-weight-bold text-muted small">Thường trú (Xã / Phường) <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control type="text" value={thuongTruXaPhuong} disabled className="shadow-none bg-white" />
                                                </Form.Group>
                                            </Col>
                                            <Col md={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="font-weight-bold text-muted small">Thường trú (Địa chỉ chi tiết) <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control type="text" value={thuongTruDiaChi} disabled className="shadow-none bg-white" />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="font-weight-bold text-muted small">Email <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control type="text" value={email} disabled className="shadow-none bg-white" />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="font-weight-bold text-muted small">Số điện thoại <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control type="text" value={phoneNumber} disabled className="shadow-none bg-white" />
                                                </Form.Group>
                                            </Col>
                                            <Col md={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="font-weight-bold text-muted small">Đơn vị công tác <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control type="text" value={donViName} disabled className="shadow-none bg-white" />
                                                </Form.Group>
                                            </Col>
                                            <Col md={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="font-weight-bold text-muted small">Nơi sinh (Tỉnh / Thành phố) <span className="text-danger">*</span></Form.Label>
                                                    <Select
                                                        isClearable
                                                        options={provinceOptions}
                                                        value={values.noiSinh ? provinceOptions.find(p => p.label === values.noiSinh) : null}
                                                        onChange={(val) => setFieldValue('noiSinh', val ? val.label : '')}
                                                        placeholder="Chọn nơi sinh..."
                                                        className="shadow-none"
                                                        menuPosition="fixed"
                                                    />
                                                    {submitCount > 0 && errors.noiSinh && <div className="text-danger small mt-1">{errors.noiSinh}</div>}
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="font-weight-bold text-muted small">Họ tên người liên hệ <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="hoTenNguoiLienHe"
                                                        placeholder="Nhập họ tên người liên hệ..."
                                                        value={values.hoTenNguoiLienHe}
                                                        onChange={handleChange}
                                                        className="shadow-none"
                                                    />
                                                    {submitCount > 0 && errors.hoTenNguoiLienHe && (
                                                        <div className="text-danger small mt-1">{errors.hoTenNguoiLienHe}</div>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="font-weight-bold text-muted small">Quan hệ</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="quanHeNguoiLienHe"
                                                        placeholder="Nhập quan hệ với người liên hệ..."
                                                        value={values.quanHeNguoiLienHe}
                                                        onChange={handleChange}
                                                        className="shadow-none"
                                                    />
                                                    {submitCount > 0 && errors.quanHeNguoiLienHe && (
                                                        <div className="text-danger small mt-1">{errors.quanHeNguoiLienHe}</div>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="font-weight-bold text-muted small">SĐT người liên hệ <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="sdtNguoiLienHe"
                                                        placeholder="Nhập số điện thoại người liên hệ..."
                                                        value={values.sdtNguoiLienHe}
                                                        onChange={handleChange}
                                                        className="shadow-none"
                                                    />
                                                    {submitCount > 0 && errors.sdtNguoiLienHe && (
                                                        <div className="text-danger small mt-1">{errors.sdtNguoiLienHe}</div>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                            <Col md={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="font-weight-bold text-muted small d-block">Bạn có thuộc đối tượng miễn giảm? <span className="text-danger">*</span></Form.Label>
                                                    <div>
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="Có"
                                                            name="isDoiTuongMienGiam"
                                                            value="true"
                                                            checked={values.isDoiTuongMienGiam === 'true'}
                                                            onChange={handleChange}
                                                        />
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="Không"
                                                            name="isDoiTuongMienGiam"
                                                            value="false"
                                                            checked={values.isDoiTuongMienGiam === 'false'}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                    {submitCount > 0 && errors.isDoiTuongMienGiam && <div className="text-danger small mt-1">{errors.isDoiTuongMienGiam}</div>}
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </div>
                                </Tab>

                                <Tab eventKey="thong-tin-du-tuyen" title={<span><i className="fas fa-clipboard-list mr-1"></i> Thông tin đăng ký dự tuyển</span>}>
                                    <div className="bg-light p-3 rounded border mt-3">
                                        <Row>
                                            <Col md={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="font-weight-bold text-muted small">Tên khóa học <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control type="text" value={tenKhoaHoc} disabled className="shadow-none bg-white font-weight-bold" />
                                                </Form.Group>
                                            </Col>
                                            {soHoSoDisplay && (
                                                <Col md={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="font-weight-bold text-muted small">Số hồ sơ</Form.Label>
                                                        <Form.Control type="text" value={soHoSoDisplay} disabled className="shadow-none bg-white font-weight-bold text-primary" />
                                                    </Form.Group>
                                                </Col>
                                            )}
                                            {loaiTuyenSinh === 2 && (
                                                <Col md={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="font-weight-bold text-muted small">Chức danh đăng ký đào tạo <span className="text-danger">*</span></Form.Label>
                                                        <Select
                                                            isClearable
                                                            options={chucDanhOptions}
                                                            value={chucDanhOptions.find(n => String(n.value).toLowerCase() === String(values.chucDanhId).toLowerCase()) || null}
                                                            onChange={(val) => setFieldValue('chucDanhId', val ? val.value : null)}
                                                            placeholder="Chọn chức danh đăng ký đào tạo..."
                                                            className="shadow-none"
                                                            menuPosition="fixed"
                                                        />
                                                        {submitCount > 0 && errors.chucDanhId && <div className="text-danger small mt-1">{errors.chucDanhId}</div>}
                                                        {values.chucDanhId && itemAccountInfo?.chucDanhChuyenMonId && String(values.chucDanhId).toLowerCase() !== String(itemAccountInfo.chucDanhChuyenMonId).toLowerCase() && (
                                                            <div className="text-warning small mt-1">
                                                                <i className="fas fa-exclamation-triangle mr-1"></i> Chức danh bạn đăng ký đang khác chức danh chuyên môn của bạn trong Profile
                                                            </div>
                                                        )}
                                                    </Form.Group>
                                                </Col>
                                            )}
                                        </Row>
                                    </div>
                                </Tab>

                                <Tab eventKey="dao-tao" title={<span><i className="fas fa-graduation-cap mr-1"></i> Quá trình đào tạo</span>}>
                                    <div className="bg-light p-4 rounded border mt-3 mb-4 mx-4 shadow-sm">
                                        <h5 className="font-weight-bold mb-3 border-bottom pb-2" style={{ color: "#1e7e34" }}>
                                            <i className="fas fa-award mr-2"></i> Thông tin văn bằng
                                        </h5>
                                        <FieldArray name="vanBangDaiHocs">
                                            {({ push, remove }) => (
                                                <>
                                                    {values.vanBangDaiHocs.map((vb, index) => {
                                                        const vbErrors = (errors.vanBangDaiHocs && errors.vanBangDaiHocs[index]) || {};
                                                        return (
                                                        <div key={index} className="p-3 mb-3 bg-white border rounded position-relative">
                                                            {index > 0 && (
                                                                <div className="position-absolute" style={{ top: '10px', right: '10px', zIndex: 10 }}>
                                                                    <BootstrapButton type="button" variant="outline-danger" size="sm" onClick={() => remove(index)} title="Xóa văn bằng">
                                                                        <i className="fas fa-trash"></i>
                                                                    </BootstrapButton>
                                                                </div>
                                                            )}
                                                            <Row>
                                                                <Col md={4} className="mb-3">
                                                                    <Form.Label className="font-weight-bold text-muted small">Loại văn bằng <span className="text-danger">*</span></Form.Label>
                                                                    <Form.Control as="select" name={`vanBangDaiHocs.${index}.loaiVanBang`} value={vb.loaiVanBang} onChange={(e) => {
                                                                        handleChange(e);
                                                                        setFieldValue(`vanBangDaiHocs.${index}.donViDaoTaoId`, '');
                                                                        setFieldValue(`vanBangDaiHocs.${index}.tenTruongNuocNgoai`, '');
                                                                    }} isInvalid={submitCount > 0 && !!vbErrors.loaiVanBang}>
                                                                        {objectLoaiVanBang.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                                                                    </Form.Control>
                                                                    <Form.Control.Feedback type="invalid">{vbErrors.loaiVanBang}</Form.Control.Feedback>
                                                                </Col>
                                                                {parseInt(vb.loaiVanBang) === loaiVanBangValue.vanBangTrongNuoc && (
                                                                    <Col md={8} className="mb-3">
                                                                        <Form.Label className="font-weight-bold text-muted small">Trường đào tạo <span className="text-danger">*</span></Form.Label>
                                                                        <Select 
                                                                            options={donViDaoTaoOptions} 
                                                                            value={donViDaoTaoOptions.find(x => x.value === vb.donViDaoTaoId)} 
                                                                            onChange={(val) => setFieldValue(`vanBangDaiHocs.${index}.donViDaoTaoId`, val ? val.value : '')}
                                                                            placeholder="Chọn trường đào tạo" 
                                                                            isClearable 
                                                                        />
                                                                        {submitCount > 0 && vbErrors.donViDaoTaoId && <div className="text-danger small mt-1">{vbErrors.donViDaoTaoId}</div>}
                                                                    </Col>
                                                                )}
                                                                {parseInt(vb.loaiVanBang) === loaiVanBangValue.nuocNgoai && (
                                                                    <Col md={8} className="mb-3">
                                                                        <Form.Label className="font-weight-bold text-muted small">Tên trường (Nước ngoài) <span className="text-danger">*</span></Form.Label>
                                                                        <Form.Control type="text" name={`vanBangDaiHocs.${index}.tenTruongNuocNgoai`} value={vb.tenTruongNuocNgoai} onChange={handleChange} isInvalid={submitCount > 0 && !!vbErrors.tenTruongNuocNgoai} placeholder="Nhập tên trường" />
                                                                        <Form.Control.Feedback type="invalid">{vbErrors.tenTruongNuocNgoai}</Form.Control.Feedback>
                                                                    </Col>
                                                                )}
                                                                <Col md={4} className="mb-3">
                                                                    <Form.Label className="font-weight-bold text-muted small">Quốc gia <span className="text-danger">*</span></Form.Label>
                                                                    <Select 
                                                                        options={quocGiaOptions} 
                                                                        value={quocGiaOptions.find(x => x.value === vb.quocGiaId)} 
                                                                        onChange={(val) => setFieldValue(`vanBangDaiHocs.${index}.quocGiaId`, val ? val.value : '')}
                                                                        placeholder="Chọn quốc gia" 
                                                                        isClearable 
                                                                    />
                                                                    {submitCount > 0 && vbErrors.quocGiaId && <div className="text-danger small mt-1">{vbErrors.quocGiaId}</div>}
                                                                </Col>
                                                                <Col md={4} className="mb-3">
                                                                    <Form.Label className="font-weight-bold text-muted small">Hệ đào tạo <span className="text-danger">*</span></Form.Label>
                                                                    <Select 
                                                                        options={trinhDoOptions} 
                                                                        value={trinhDoOptions.find(x => x.value === vb.trinhDoId) || null} 
                                                                        onChange={(val) => setFieldValue(`vanBangDaiHocs.${index}.trinhDoId`, val ? val.value : '')}
                                                                        placeholder="Chọn hệ đào tạo" 
                                                                        isClearable 
                                                                        className="shadow-none"
                                                                    />
                                                                    {submitCount > 0 && vbErrors.trinhDoId && <div className="text-danger small mt-1">{vbErrors.trinhDoId}</div>}
                                                                </Col>
                                                                <Col md={4} className="mb-3">
                                                                    <Form.Label className="font-weight-bold text-muted small">Năm tốt nghiệp <span className="text-danger">*</span></Form.Label>
                                                                    <Form.Control type="number" name={`vanBangDaiHocs.${index}.namTotNghiep`} value={vb.namTotNghiep} onChange={handleChange} placeholder="Năm tốt nghiệp" className="shadow-none" />
                                                                    {submitCount > 0 && vbErrors.namTotNghiep && <div className="text-danger small mt-1">{vbErrors.namTotNghiep}</div>}
                                                                </Col>
                                                                <Col md={12} className="mb-2">
                                                                    <DocumentInput labelTitle={<span>File minh chứng <span className="text-danger">*</span></span>} value={vb.fileMinhChung} onChangeProp={(val) => setFieldValue(`vanBangDaiHocs.${index}.fileMinhChung`, val)} />
                                                                    {submitCount > 0 && vbErrors.fileMinhChung && !vb.fileMinhChung && <div className="text-danger small mt-1">{vbErrors.fileMinhChung}</div>}
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    )})}
                                                    <div className="text-center mt-3">
                                                        <BootstrapButton variant="outline-primary" size="sm" onClick={() => push({ loaiVanBang: loaiVanBangValue.vanBangTrongNuoc, donViDaoTaoId: '', tenTruongNuocNgoai: '', quocGiaId: quocGiaOptions?.find(q => q.label.toLowerCase() === 'việt nam' || q.label.toLowerCase() === 'viet nam')?.value || '', trinhDoId: '', namTotNghiep: '', fileMinhChung: '' })}>
                                                            <i className="fas fa-plus mr-1"></i> Thêm văn bằng
                                                        </BootstrapButton>
                                                    </div>
                                                </>
                                            )}
                                        </FieldArray>
                                        
                                        <div className="mt-4 pt-2">
                                            <h5 className="font-weight-bold mb-3 border-bottom pb-2" style={{ color: "#1e7e34" }}>
                                                <i className="fas fa-file-alt mr-2"></i> Các văn bằng khác liên quan đến khóa học (Nếu có) 
                                            </h5>
                                            <Row>
                                                <Col md={12}>
                                                    <DocumentInput 
                                                        multiple={true}
                                                        labelTitle={<span>File văn bằng</span>} 
                                                        value={values.fileVanBangKhac} 
                                                        onChangeProp={(val) => setFieldValue('fileVanBangKhac', val && val.length > 0 ? JSON.stringify(val) : '')} 
                                                    />
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </Tab>

                                <Tab eventKey="dinh-kem" title={<span><i className="fas fa-paperclip mr-1"></i> Hồ sơ đính kèm</span>}>
                                    <div className="bg-light p-4 rounded border mt-3 mb-4 mx-4 shadow-sm">
                                        <Row>
                                            <Col md={12} className="mb-4">
                                                <DocumentInput labelTitle={<span>1. Đơn đăng ký học <span className="text-danger">*</span></span>} value={values.fileDonXinDuTuyen} onChangeProp={(val) => setFieldValue('fileDonXinDuTuyen', val)} />
                                                {submitCount > 0 && errors.fileDonXinDuTuyen && !values.fileDonXinDuTuyen && <div className="text-danger small mt-1">{errors.fileDonXinDuTuyen}</div>}
                                            </Col>
                                            <Col md={12} className="mb-4">
                                                <DocumentInput labelTitle={<span>2. Bằng tốt nghiệp (công chứng) <span className="text-danger">*</span></span>} value={values.fileBangTotNghiep} onChangeProp={(val) => setFieldValue('fileBangTotNghiep', val)} />
                                                {submitCount > 0 && errors.fileBangTotNghiep && !values.fileBangTotNghiep && <div className="text-danger small mt-1">{errors.fileBangTotNghiep}</div>}
                                            </Col>
                                            <Col md={12} className="mb-4">
                                                <DocumentInput labelTitle={<span>3. Sơ yếu lý lịch (có dấu xác nhận của địa phương) <span className="text-danger">*</span></span>} value={values.fileSoYeuLyLich} onChangeProp={(val) => setFieldValue('fileSoYeuLyLich', val)} />
                                                {submitCount > 0 && errors.fileSoYeuLyLich && !values.fileSoYeuLyLich && <div className="text-danger small mt-1">{errors.fileSoYeuLyLich}</div>}
                                            </Col>
                                            <Col md={12} className="mb-4">
                                                <DocumentInput multiple={true} labelTitle={<span>4. Ảnh chân dung 3x4 và 4x6 (02 ảnh) <span className="text-danger">*</span></span>} value={values.fileAnhChanDung} onChangeProp={(val) => setFieldValue('fileAnhChanDung', val && val.length > 0 ? JSON.stringify(val) : '')} />
                                                {submitCount > 0 && errors.fileAnhChanDung && !values.fileAnhChanDung && <div className="text-danger small mt-1">{errors.fileAnhChanDung}</div>}
                                            </Col>
                                            <Col md={12} className="mb-4">
                                                <DocumentInput labelTitle={<span>5. Căn cước công dân photo <span className="text-danger">*</span></span>} value={values.fileAnhCccd} onChangeProp={(val) => setFieldValue('fileAnhCccd', val)} />
                                                {submitCount > 0 && errors.fileAnhCccd && !values.fileAnhCccd && <div className="text-danger small mt-1">{errors.fileAnhCccd}</div>}
                                            </Col>
                                            {values.isDoiTuongMienGiam === 'true' && (
                                                <Col md={12} className="mb-4">
                                                    <DocumentInput labelTitle={<span>6. Minh chứng thuộc đối tượng miễn giảm (nếu thuộc đối tượng miễn giảm)</span>} value={values.fileMinhChungMienGiam} onChangeProp={(val) => setFieldValue('fileMinhChungMienGiam', val)} />
                                                </Col>
                                            )}
                                        </Row>
                                    </div>
                                </Tab>
                            </Tabs>
                        </Modal.Body>
                        <Modal.Footer>
                            <BootstrapButton variant="secondary" onClick={handleClose} disabled={isSubmitting}>
                                Hủy
                            </BootstrapButton>
                            <BootstrapButton variant="primary" type="submit" disabled={isSubmitting}>
                                {isSubmitting ? (
                                    <>Đang lưu...</>
                                ) : (
                                    <>Lưu hồ sơ</>
                                )}
                            </BootstrapButton>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </Modal>
    );
};

export default DangKyHoSoLopDaoTaoModal;
